<template>
    <div class="form-group" :class="{ 'mb-4': !removeMargin }">
        <label>
            <strong>{{ title }}</strong>
        </label>
        <p class="mb-0" v-if="subtitle">
            <small>{{ subtitle }}</small>
        </p>
        <div class="input-group align-items-center">
            <div class="form-check form-check-inline">
                <label class="form-check-label">
                    Any
                    <input
                        :name="uniqueName"
                        v-model="internalTime"
                        value="Any"
                        class="form-check-input"
                        type="radio"
                    >
                </label>
            </div>
            <div class="form-check form-check-inline">
                <label class="form-check-label">
                    AM
                    <input
                        :name="uniqueName"
                        v-model="internalTime"
                        value="AM"
                        class="form-check-input"
                        type="radio"
                    >
                </label>
            </div>
            <div class="form-check form-check-inline">
                <label class="form-check-label">
                    PM
                    <input
                        :name="uniqueName"
                        v-model="internalTime"
                        value="PM"
                        class="form-check-input"
                        type="radio"
                    >
                </label>
            </div>
            <div class="form-check form-check-inline">
                <label class="form-check-label">
                    Evening
                    <input
                        :name="uniqueName"
                        v-model="internalTime"
                        value="Evening"
                        class="form-check-input"
                        type="radio"
                    >
                </label>
            </div>
            <div class="form-check form-check-inline">
                <label class="form-check-label">
                    Night
                    <input
                        :name="uniqueName"
                        v-model="internalTime"
                        value="Night"
                        class="form-check-input"
                        type="radio"
                    >
                </label>
            </div>
            <div class="form-check form-check-inline d-flex align-items-center">
                <input
                    :id="uniqueId"
                    :name="uniqueName"
                    value="Specific"
                    :checked="isSpecificChecked"
                    @change="onSpecificRadioChange"
                    class="form-check-input me-2"
                    style="margin-top: -2px;"
                    type="radio"
                >
                <input
                    class="form-control flatpicker-time-only"
                    style="margin-top: -2px;"
                    placeholder="hh:ii"
                    maxlength="5"
                    ref="timeSpecificInput"
                    v-model="internalTime"
                    @focus="onSpecificRadioChange"
                >
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, watch, onMounted, computed, useId } from 'vue';
import flatpickr from "flatpickr";

const props = defineProps({
    title: {
        type: String,
        required: true
    },
    subtitle: {
        type: String,
        required: false
    },
    time: {
        type: String,
        default: 'Any',
        required: false,
    },
    removeMargin: {
        type: Boolean,
        default: false,
        required: false
    },
});

const emit = defineEmits(['update-time']);

// Internal Time. A time can be passed in as a prop. If the prop is set then use that, otherwise default to 'Any'
const internalTime = ref(props.time ?? 'Any');

// This time is maintained as a copy of internalTime when the user selects a specific time
const specificTime = ref('12:00');
const uniqueName = `internal-time-${useId()}`;
const uniqueId = `time-input-${useId()}`;

const timeSpecificInput = ref(null);

const isSpecificChecked = computed(() => {
    return !['Any','AM','PM','Evening','Night'].includes(internalTime.value);
});

const onSpecificRadioChange = () => {
    internalTime.value = specificTime.value;
    // When the official API don't work you can always trust a jQuery scuff
    window.jQuery('#' + uniqueId).siblings('.flatpicker-time-only').click();
}

onMounted(() => {
    flatpickr(timeSpecificInput.value, {
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i",
        time_24hr: true,
        altInput: true,
        defaultDate: isSpecificChecked.value ? internalTime.value : specificTime.value,
    });
});

watch(() => props.time, (value) => {
    internalTime.value = value ?? 'Any';
});

watch(internalTime, (value) => {
    if (isSpecificChecked.value) {
        specificTime.value = internalTime.value;
    }
    emit('update-time', value);
});
</script>
